
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSend as ObiSendElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-send.js';
 
 
 

 
 export const ObiSend = createComponent({
   react: React,
   tagName: 'obi-send',
   elementClass: ObiSendElement,
   events: {
     
   }
  });
 
 